//library
import { CImage, CToast, CToastBody, CToastClose, CToaster } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

//assets
import successIcon from '../../asset/icon/Success.svg'
import infoIcon from '../../asset/icon/Info-blue.svg'
import errorIcon from '../../asset/icon/alert-red.svg'
import alertIcon from '../../asset/icon/alert-orange.svg'

//styles
import './toast-message.style.scss'
import { useDispatch } from 'react-redux'
import { setDisplayMessage } from 'src/redux/slices/login.slice'
import { closeIcon } from 'src/asset/icon'

/**
@param
 @key {String} message : '' ,
 @key {String} type : default value is 'success',
 @key {Bool} autoHide : default value is false ,
 @key {String} placement : default value is top-center ,
 @key {String} size : default value is lg ,

*/

const setImage = (type) => {
  switch (type) {
    case 'information':
      return infoIcon
    case 'alert':
      return alertIcon
    case 'error':
      return errorIcon
    default:
      return successIcon
  }
}

const ToastMessage = (props) => {
  const {
    message = null,
    type = 'success',
    autoHide = true,
    size = 'lg',
    placement = 'top-center',
    messageTitle = '',
    isSecondaryToast = false,
  } = props

  const dispatch = useDispatch()
  const [primaryToast, setPrimaryToast] = useState(null)
  const [secondaryToast, setSecondaryToast] = useState(null)

  useEffect(() => {
    if (!message) return

    const toastData = { message, type, autoHide, size, placement, messageTitle }

    if (isSecondaryToast) {
      setSecondaryToast(toastData)
    } else {
      setPrimaryToast(toastData)
    }
  }, [message, type, autoHide, size, placement, messageTitle, isSecondaryToast])

  const handleOnClosed = (isSecondary) => {
    if (isSecondary) {
      setSecondaryToast(null)
    } else {
      setPrimaryToast(null)
    }

    dispatch(setDisplayMessage(null))
  }

  const renderToast = (toastData, isSecondary) => {
    if (!toastData) return null

    const { message, type, autoHide, size, messageTitle } = toastData

    return (
      <CToast
        autohide={autoHide}
        delay={3000}
        visible={true}
        className={`toast-message toast-message--${size} toast-message--${type}`}
        onClose={() => handleOnClosed(isSecondary)}
        size={size}
      >
        <div className="d-flex align-items-start m-auto gap-2">
          <div className="d-flex justify-content-start flex-grow-1 toast-message__box">
            <CToastBody className="d-flex justify-content-start align-items-start gap-2 p-0">
              <CImage src={setImage(type)} id="toastMessageIcon" />
              <p id="toastMessageText" className="toast-message__text m-0 align-self-center">
                <span className="toast-message__title">{messageTitle || type} : </span>
                {typeof message === 'string'
                  ? message.split('\n').map((line, idx) => (
                      <React.Fragment key={idx}>
                        {line}
                        {idx < message.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ))
                  : message}
              </p>
            </CToastBody>
          </div>
          <CImage
            id="toastMessageCloseIcon"
            src={closeIcon}
            alt="close"
            className="cursor-pointer pt-1"
            onClick={() => handleOnClosed(isSecondary)}
          />
        </div>
      </CToast>
    )
  }

  return (
    <CToaster placement={placement}>
      {primaryToast && renderToast(primaryToast, false)}
      {secondaryToast && renderToast(secondaryToast, true)}
    </CToaster>
  )
}


ToastMessage.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['information', 'success', 'error', 'alert']),
  autoHide: PropTypes.bool,
  size: PropTypes.oneOf(['lg', 'md']),
  messageTitle: PropTypes.string,
  placement: PropTypes.oneOf([
    'top-start',
    'top-center',
    'top-end',
    'bottom-start',
    'bottom-center',
    'bottom-end',
  ]),
  isSecondaryToast: PropTypes.bool,
}

export default ToastMessage
